export enum BookingStep {
  SearchForm = 'SearchForm',
  RoomSelection = 'RoomSelection',
  AdditionalInfo = 'AdditionalInfo',
  Payment = 'Payment',
  Confirmation = 'Confirmation',
}
